export const createTime = (count = 90) => {
  const time = new Date();
  time.setSeconds(time.getSeconds() + count);
  return time;
};
